import { Link } from "react-router-dom";
import { Reveal } from "../components/Reveal";
import { useT } from "../lib/LanguageContext";
import { PILLAR_SLUGS as SLUGS } from "../lib/serviceCategories";
import { RichText } from "../components/RichText";

const LAPTOP_STRATEGY =
  "https://customer-assets.emergentagent.com/job_digital-monaco/artifacts/y5lpq1mg_Copie%20de%20Menu%20insta%20.png";
const IPHONE_IMG =
  "https://customer-assets.emergentagent.com/job_digital-monaco/artifacts/xcde0e7h_6.png";

const SERVICE_IMGS = {
  "creation-de-contenu":
    "https://customer-assets.emergentagent.com/job_digital-monaco/artifacts/u0ard9na_17.jpg",
  "social-media-management":
    "https://customer-assets.emergentagent.com/job_digital-monaco/artifacts/emctsyoy_14.jpg",
  "branding-identite-visuelle":
    "https://customer-assets.emergentagent.com/job_digital-monaco/artifacts/pyw9u7yk_12.jpg",
  "creations-print":
    "https://customer-assets.emergentagent.com/job_digital-monaco/artifacts/uze30up0_8.jpg",
};

const Vision = () => {
  const { t } = useT();
  return (
    <main data-testid="page-vision" className="bg-white">
      <section className="pt-40 pb-20 px-6 bg-[#FFFBEA]">
        <div className="max-w-7xl mx-auto">
          <Reveal>
            <h1 className="font-serif text-5xl md:text-7xl font-bold text-[#6B5CE7]">{t("vision.title")}</h1>
          </Reveal>
          <Reveal delay={0.15}>
            <p className="mt-8 text-lg md:text-xl text-[#4A4558] max-w-3xl font-light leading-relaxed"><RichText text={t("vision.p1")} /></p>
            <p className="mt-4 text-lg md:text-xl text-[#4A4558] max-w-3xl font-light leading-relaxed"><RichText text={t("vision.p2")} /></p>
          </Reveal>
        </div>
      </section>

      <section className="px-6 py-16">
        <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-6">
          <Reveal>
            <img src={LAPTOP_STRATEGY} alt="" className="w-full aspect-square object-cover rounded-2xl shadow-xl" />
          </Reveal>
          <Reveal delay={0.15}>
            <img src={IPHONE_IMG} alt="" className="w-full aspect-square object-cover rounded-2xl shadow-xl" />
          </Reveal>
        </div>
      </section>

      <section className="py-24 px-6">
        <div className="max-w-4xl mx-auto space-y-5 text-[#4A4558] font-light text-base md:text-lg leading-relaxed">
          <Reveal><p><RichText text={t("vision.block1")} /></p></Reveal>
          <Reveal delay={0.15}><p><RichText text={t("vision.block2")} /></p></Reveal>
        </div>
      </section>

      <section className="py-24 px-6 bg-[#FFFBEA]">
        <div className="max-w-7xl mx-auto">
          <Reveal>
            <h2 className="font-serif text-3xl md:text-5xl uppercase text-[#6B5CE7] font-bold mb-12">
              {t("vision.piliersTitle")}
            </h2>
          </Reveal>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {SLUGS.map((slug, i) => (
              <Reveal key={slug} delay={i * 0.08}>
                <Link
                  to={`/service/${slug}`}
                  data-testid={`service-card-${slug}`}
                  className="group block bg-white rounded-2xl overflow-hidden shadow-md hover:shadow-2xl transition-all duration-500 hover:-translate-y-1"
                >
                  <div className="overflow-hidden aspect-square">
                    <img
                      src={SERVICE_IMGS[slug]}
                      alt=""
                      className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                    />
                  </div>
                  <div className="p-6">
                    <span data-testid={`pillar-num-${slug}`} className="block text-xs tracking-[0.3em] text-[#6B5CE7] font-medium mb-3">
                      {String(i + 1).padStart(2, "0")}
                    </span>
                    <h3 className="font-serif text-lg text-[#1A1528] font-semibold mb-4 min-h-[3rem]">
                      {t(`vision.services.${slug}`)}
                    </h3>
                    <span
                      data-testid={`service-cta-${slug}`}
                      className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.2em] text-[#6B5CE7] font-medium group-hover:text-[#4D3FC8] transition-colors"
                    >
                      {t("common.enSavoirPlus")} →
                    </span>
                  </div>
                </Link>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </main>
  );
};

export default Vision;
